<script>
import {getCurrentInstance, onMounted, onBeforeUnmount} from 'vue';
import commonFn from '@/commons/commonFunction';
import EventBusGlobal from '@/commons/eventBusGlobal';

export default {
  components: {},
  props: {
    title: String,
    width: {
      type: Number,
      default: 400,
    },
    message: [String, Array],
    type: {
      type: Number,
      default: 0,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const {proxy} = getCurrentInstance();

    const closeDialog = () => proxy.$close(proxy, null);

    onMounted(() => {
      // focus button
      commonFn.focusFirstControl(proxy.$refs['msg']);
      EventBusGlobal.$on('MsBottomRightMessageBox/close', closeDialog);
    });

    function escPress(e, close) {
      e.preventDefault();
      close(this, null);
    }

    onBeforeUnmount(() => {
      EventBusGlobal.$off('MsBottomRightMessageBox/close', closeDialog);
    });

    return {
      escPress,
    };
  },
};
</script>

<template>
  <div class="msg-box msg-bottom-right" @keydown.esc="escPress($event, $close)">
    <div ref="msg" class="msg-center" :style="{width: width + 'px'}">
      <div class="msg-title">
        {{ title }}
      </div>
      <div v-if="!hideClose" class="msg-close icon24 close" @click="$close(this, null)" />
      <div class="msg-message">
        <template v-if="Array.isArray(message)">
          <div v-for="(item, i) in message" :key="i" class="msg-item" v-html="item" />
        </template>

        <div v-else-if="!Array.isArray(message)" class="msg-item" v-html="message" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/scss/components/MsMessageBox.scss';
.msg-bottom-right {
  &.msg-box {
    position: fixed;
    top: unset;
    left: unset;
    bottom: 40px;
    right: 40px;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
  }

  .msg-center {
    position: absolute;
    right: 0px;
    bottom: 0px;
    height: 100px;
    transform: translate(-100%, -100%);
    background-color: white;
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.08);
    border-radius: $border-radius;
  }

  .msg-close {
    top: 20px;
    right: 20px;
    transform: scale(0.8);
  }

  a {
    color: $blue-text;
  }
}
</style>
